import React from "react";

const NewPage = () => {
  return <div>Cooming soon</div>;
};

export default NewPage;
